import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "form-group__wrapper" }
const _hoisted_2 = ["for"]
const _hoisted_3 = {
  key: 0,
  class: "form-group__tooltip"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconTooltip = _resolveComponent("IconTooltip")!
  const _component_VueMultiselect = _resolveComponent("VueMultiselect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      for: $props.slug,
      class: _normalizeClass(["form-group__label", { disabled: $props.isDisabled, isSmall: $props.isSmallLabel }])
    }, [
      _createTextVNode(_toDisplayString($props.label) + ": ", 1 /* TEXT */),
      ($props.description)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_IconTooltip, {
              tooltipMessage: $props.description,
              isHtml: true
            }, null, 8 /* PROPS */, ["tooltipMessage"])
          ]))
        : _createCommentVNode("v-if", true)
    ], 10 /* CLASS, PROPS */, _hoisted_2),
    _createVNode(_component_VueMultiselect, {
      className: "filterMultiselect",
      modelValue: $data.selectedValues,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.selectedValues) = $event)),
      maxHeight: "85",
      options: $props.filterValues,
      label: "title",
      "hide-selected": true,
      "track-by": "title",
      searchable: false,
      multiple: true,
      openDirection: "bottom",
      closeOnSelect: true,
      showPointer: false,
      onSelect: $options.handleSelectedValues,
      onRemove: $options.handleSelectedValues
    }, null, 8 /* PROPS */, ["modelValue", "options", "onSelect", "onRemove"])
  ]))
}